// extracted by extract-css-chunks-webpack-plugin
module.exports = {"punchCard":"PunchCard-367b5c2098ac8cd5","placeholder":"PunchCard-ffecb5cd8cfb2d39","punchCardImage":"PunchCard-4c8ba966272db1b1"};